import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ServiceCRUD } from '../../../shared/crud/ServiceCRUD';

@Injectable()
export class VeiculoRegionalService extends ServiceCRUD {
  private baseUrlService: string;
  public carregando = true;

  private valorRecebido = new BehaviorSubject<any>(null);
  valorModal$ = this.valorRecebido.asObservable();

  constructor(public httpClient: HttpClient, router: Router, protected toastr: ToastrService) {
    super(httpClient, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return `${this.baseUrlService}/veiculo_daily_report`;
  }

  public getDados(
    data_inicial?: any,
    data_final?: any,
    dealers?: any,
    idRegional?: any,
    tipoRelatorio?: 'regional' | 'faturamentoDiario'
  ): Observable<any> {


    let params = new HttpParams();

    // Converter formato de data de DD-MM-YYYY para YYYY-MM-DD
    if (data_inicial) {
      const dataInicialFormatada = this.formatarDataParaAPI(data_inicial);
      params = params.set('dataInc', dataInicialFormatada);
    }
    if (data_final) {
      const dataFinalFormatada = this.formatarDataParaAPI(data_final);
      params = params.set('dataFim', dataFinalFormatada);
    }
    if (dealers) params = params.set('dealers', dealers.toString());
    if (idRegional) params = params.set('idRegional', idRegional.toString());

    // Definir endpoint baseado no tipo de relatório
    let endpoint: string;
    switch(tipoRelatorio) {
      case 'faturamentoDiario':
        endpoint = `${this.baseUrlService}/relatorio_veiculo/faturamento_diario`;
        break;
      case 'regional':
      default:
        endpoint = `${this.baseUrlService}/relatorio_veiculo/relatorio_regional_mensal`;
        break;
    }

    return this.httpClient.get<any>(endpoint, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      }),
      params: params
    });
  }

  private formatarDataParaAPI(data: string): string {
    // Converte DD-MM-YYYY para YYYY-MM-DD
    if (data && data.includes('-')) {
      const partes = data.split('-');
      if (partes.length === 3) {
        return `${partes[2]}-${partes[1]}-${partes[0]}`;
      }
    }
    return data;
  }

  atualizarModal(event: any) {
    this.valorRecebido.next(event)
  }

  receberValorModal() {
    return this.valorRecebido.getValue()
  }
}
